export default {
    button: {
        padding: "6px 22px",
        margin: "0px 5px",
        flexGrow:"1"
    },

    buttonContainer: {
        display: "flex",
        flexWrap: "wrap",
        columnGap: "15px",
        margin: "20px 0 0px",
        alignItems: "center",
        justifyContent: "space-between",
    },

    linkButton: {
        color: "rgb(103, 103, 103)",
        borderRadius: "0px",
        background: "inherit",
        borderTop: "none",
        borderRight: "none",
        borderBottom: "none",
        borderLeft: "none",
    },

    activeLinkButton: {
        borderBottom: "2px solid #215DAA",
        color: "rgb(33, 93, 170)",
    },
    createButtonsContainer: {
        display: "flex",
        flexDirection: "row",
        gap: "20px",
        justifyContent: "flex-end",
        marginBottom: "10px",
    },
    horizontalSeparator: { 
        marginBottom: "20px" 
    }
}